
<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>
                <span *ngIf="this.selectedOrganizationName">
                    {{ this.selectedOrganizationName }}
                </span>
                Guests
            </h1>
        </div>
        @if (screenGuestEnabled) {
            <div class="d-flex mt-2 me-1">
                <button 
                    mat-raised-button
                    class="action-button d-flex col-auto align-items-center"
                    (click)="onNewGuestClick()">
                    <mat-icon>add</mat-icon>
                    Screen a Guest
                </button>
            </div>
        }
    </div>
    <mat-card class="mt-3 pb-5" style="min-height:500px;">
        <div id="legend-container">
            <div class="d-flex align-items-center">
                <h2 id="legend-header" class="text-muted">Screening Result Legend</h2>
            </div>
            <div class="d-flex flex-row mt-2" [style.display]="legendVisible ? 'flex': 'none !important'">
                <div class="d-flex flex-row align-items-center">
                    <mat-chip class="legend-table-chip" [style.backgroundColor]="getColor(colorProp.GuestSuccess)"></mat-chip>
                    <div class="mx-2 legend-chip-name">Success</div>
                </div>
                <div class="d-flex flex-row align-items-center legend-element">
                    <mat-chip class="legend-table-chip" [style.backgroundColor]="getColor(colorProp.GuestConsider)"></mat-chip>
                    <div class="mx-2 legend-chip-name">Consider</div>
                </div>
                <div class="d-flex flex-row align-items-center legend-element">
                    <mat-chip class="legend-table-chip" [style.backgroundColor]="getColor(colorProp.GuestProcessing)"></mat-chip>
                    <div class="mx-2 legend-chip-name">Processing</div>
                </div>
                <div class="d-flex flex-row align-items-center legend-element">
                    <mat-chip class="legend-table-chip" [style.backgroundColor]="getColor(colorProp.GuestDefault)"></mat-chip>
                    <div class="mx-2 legend-chip-name">No Screening</div>
                </div>
            </div>
        </div>
        <div class="row pt-3 align-items-center">
            <div class="col-lg-9 col-12 d-flex flex-column my-2" id="filters-container">
                <div class="d-flex flex-row align-items-center">
                    <mat-icon *ngIf="filterDefinitions && filterDefinitions.length > 0" class="filter-icon">filter_list</mat-icon>
                    <app-data-table-filter 
                        class="filter" 
                        *ngFor="let filterDefinition of filterDefinitions" 
                        [filterDefinition]="filterDefinition" 
                        [disable]="loading"
                    >
                        <ng-template #filters></ng-template>
                    </app-data-table-filter>
                </div>
            </div>
            <div class="col-lg-3 col-12 my-2">
                <mat-form-field appearance="outline" class="search-bar">
                    <mat-label class="search-bar-label">
                        <mat-icon class="search-icon">search</mat-icon>
                        <span>Search</span>
                    </mat-label>
                    <input matInput (keyup.enter)="onSearchEvent(searchKeyword)" (keyup.backspace)="onDeleteKeyUp(searchKeyword)" [(ngModel)]="searchKeyword">
                    <button type="button" *ngIf="searchKeyword" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="d-flex flex-row align-items-center pt-2" id="filter-pills-container">
                    <app-data-table-filter-pill 
                        *ngFor="let filterPill of filterPills | keyvalue" 
                        [filterState]="filterPill.value" 
                        (closeClickEvent)="onFilterPillCloseEvent($event)" 
                        [disable]="loading">
                    </app-data-table-filter-pill>
                </div>
                <div class="mt-2 mb-3">
                    <div class="table-responsive">
                        <table matSort mat-table class="table" [dataSource]="dataSource" class="mb-3" (matSortChange)="onSortEvent($event)" matSortDisableClear>
                            <ng-container matColumnDef="reservationId">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Safely Res. ID </th>
                                <td mat-cell *matCellDef="let element"> {{element.reservationId}} </td>
                            </ng-container>
                            <ng-container matColumnDef="reservationReferenceId">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Reservation ID </th>
                                <td mat-cell *matCellDef="let element"> {{element.reservationReferenceId}} </td>
                            </ng-container>
                            <ng-container matColumnDef="organizationId">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Organization ID </th>
                                <td mat-cell *matCellDef="let element"> {{element.organizationId}} </td>
                            </ng-container>
                            <ng-container matColumnDef="organizationName">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Organization Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.organizationName}} </td>
                            </ng-container>
                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell mat-sort-header mat-sort-header *matHeaderCellDef> Guest Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
                            </ng-container>
                            <ng-container matColumnDef="verifiedDate">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Date Screened </th>
                                <td mat-cell *matCellDef="let element"> {{element.verifiedDate}} </td>
                            </ng-container>
                            <ng-container matColumnDef="arrivalDate">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Arrival Date </th>
                                <td mat-cell *matCellDef="let element"> {{element.arrivalDate}} </td>
                            </ng-container>
                            <ng-container matColumnDef="verificationResultCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header"> Screening Result </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip-listbox class="mat-chip-list-stacked">
                                        <mat-chip-option [style.backgroundColor]="element.verificationResultCode?.color" class="table-chip">
                                            {{element.verificationResultCode?.text}}
                                        </mat-chip-option>
                                    </mat-chip-listbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="identityResultCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Identity'"> 
                                    I
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip [style.backgroundColor]="element.identityResultCode?.color" class="table-chip">
                                        {{element.identityResultCode?.text}}
                                    </mat-chip>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="watchlistResultCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Watchlist'"> 
                                    {{ userContextProvider.isNaUser() ? 'W' : 'S' }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip-option [style.backgroundColor]="element.watchlistResultCode?.color" class="table-chip">
                                        {{element.watchlistResultCode?.text}}
                                    </mat-chip-option>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="sexOffenderResultCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Sex Offender'">
                                    S
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip-option [style.backgroundColor]="element.sexOffenderResultCode?.color" class="table-chip">
                                        {{element.sexOffenderResultCode?.text}}
                                    </mat-chip-option>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="nationalCriminalCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Criminal'">
                                    C
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip-option [style.backgroundColor]="element.nationalCriminalCode?.color" class="table-chip">
                                        {{element.nationalCriminalCode?.text}}
                                    </mat-chip-option>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="fraudResultCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Suspicious Behavior Check'"> SB </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip-option [style.backgroundColor]="element.fraudResultCode?.color" class="table-chip">
                                        {{element.fraudResultCode?.text}}
                                    </mat-chip-option>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="badGuestResultCode">
                                <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Safely DB - Prior Rental Database'">
                                    Safely DB
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-chip-option [style.backgroundColor]="element.badGuestResultCode?.color" class="table-chip">
                                        {{element.badGuestResultCode?.text}}
                                    </mat-chip-option>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="lastEmailSent">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Last Email Sent </th>
                                <td mat-cell *matCellDef="let element"> {{element.lastEmailSent | date}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: tableColumns;" (click)="onRowClick(row)"></tr>
                            @if(loading && searchKeyword) {
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                        No data matching the filter "{{ searchKeyword }}"
                                    </td>
                                </tr>
                            }
                            @if (loading && !searchKeyword) {
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                        @if(tableLength === 0) {
                                            No Guests Data
                                        } @else {
                                            Loading Guests..
                                        }
                                    </td>
                                </tr>
                            }
                        </table>
                    </div>
                </div>
                @if(loading | async) {
                    <div class="d-flex justify-content-center align-items-center">
                        <mat-spinner></mat-spinner>
                    </div>
                }
                <div class="d-flex paginator-row align-items-baseline">
                    <div class="col-10">
                        <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [length]="tableLength"
                            [pageSize]="pageSize" aria-label="Select page" showFirstLastButtons>
                        </mat-paginator>
                    </div>
                    <div class="col-2 d-flex align-items-baseline">
                        <mat-form-field appearance="fill" class="go-to" id="goToPage">
                            <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber" step="1">
                        </mat-form-field>
                        <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</div>